"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var Hash_1 = require("./Hash");
var Spend_1 = require("./Spend");
var Output_1 = require("./Output");
var Serialization_1 = require("../../Handlers/Serialization");
var LockFactory_1 = require("./Locks/LockFactory");
var Input = /** @class */ (function () {
    function Input(input) {
        this.input = input;
    }
    Input.read = function (buffer, offset, isTxSkeleton) {
        if (isTxSkeleton === void 0) { isTxSkeleton = false; }
        var identifier = buffer.readUInt8(offset);
        offset++;
        switch (identifier) {
            case 1:
                if (isTxSkeleton) {
                    var _a = Hash_1.Hash.read(buffer, offset), txHash_1 = _a.hash, offset2 = _a.offset;
                    var _b = Serialization_1.readVarInt(buffer, offset2), index_1 = _b.value, offset3 = _b.offset;
                    var _c = Output_1.Output.read(buffer, offset3), output = _c.output, offset4 = _c.offset;
                    return {
                        input: new Input({
                            kind: 'pointedOutput',
                            outpoint: { kind: 'outpoint', txHash: txHash_1, index: index_1 },
                            output: output
                        }), offset: offset4
                    };
                }
                var _d = Hash_1.Hash.read(buffer, offset), txHash = _d.hash, txHash_offset = _d.offset;
                var _e = Serialization_1.readVarInt(buffer, txHash_offset), index = _e.value, index_offset = _e.offset;
                return {
                    input: new Input({
                        kind: 'outpoint',
                        txHash: txHash,
                        index: index
                    }), offset: index_offset
                };
            case 2:
                var _f = Spend_1.Spend.read(buffer, offset), spend = _f.spend, spend_offset = _f.offset;
                return {
                    input: new Input({
                        kind: 'mint',
                        spend: spend
                    }), offset: spend_offset
                };
            default:
                throw new Error("invalid input");
        }
    };
    Input.prototype.toJson = function () {
        switch (this.input.kind) {
            case 'pointedOutput':
                return {
                    kind: 'pointedOutput',
                    outpoint: {
                        txHash: this.input.outpoint.txHash.hash,
                        index: this.input.outpoint.index
                    },
                    output: this.input.output.toJson(),
                };
            case 'outpoint':
                return {
                    kind: 'outpoint',
                    txHash: this.input.txHash.hash,
                    index: this.input.index
                };
            case 'mint':
                return {
                    kind: 'mint',
                    asset: this.input.spend.asset.getAsset(),
                    amount: this.input.spend.amount
                };
        }
    };
    Input.prototype.toApiJson = function () {
        switch (this.input.kind) {
            case 'pointedOutput':
                return {
                    kind: 'pointedOutput',
                    outpoint: this.input.outpoint,
                    lock: LockFactory_1.LockFactory.toApiJson(this.input.output.lock),
                    spend: this.input.output.spend,
                };
            case 'outpoint':
                return {
                    outpoint: {
                        txHash: this.input.txHash.hash,
                        index: this.input.index
                    }
                };
            case 'mint':
                return {
                    mint: {
                        asset: this.input.spend.asset.getAsset(),
                        amount: this.input.spend.amount.toString()
                    }
                };
        }
    };
    Input.prototype.getSize = function () {
        switch (this.input.kind) {
            case 'pointedOutput':
                return 1 + this.input.output.getSize() + Serialization_1.getSizeOfVarInt(this.input.outpoint.index) + this.input.outpoint.txHash.getSize();
            case 'outpoint':
                return 1 + Serialization_1.getSizeOfVarInt(this.input.index) + this.input.txHash.getSize();
            case 'mint':
                return 1 + this.input.spend.getSize();
        }
    };
    Input.prototype.write = function (buffer, offset) {
        switch (this.input.kind) {
            case 'pointedOutput':
                offset = buffer.writeUInt8(1, offset);
                offset = this.input.outpoint.txHash.write(buffer, offset);
                offset = Serialization_1.writeVarInt(this.input.outpoint.index, buffer, offset);
                return this.input.output.write(buffer, offset);
            case 'outpoint':
                offset = buffer.writeUInt8(1, offset);
                offset = this.input.txHash.write(buffer, offset);
                return Serialization_1.writeVarInt(this.input.index, buffer, offset);
            case 'mint':
                offset = buffer.writeUInt8(2, offset);
                return this.input.spend.write(buffer, offset);
        }
    };
    return Input;
}());
exports.Input = Input;
//# sourceMappingURL=Input.js.map